__webpack_require__.p = "/assets/turbo/43442e8e/ackermannch/_next/";